import sv from "./styles";
import styled from '@emotion/styled'
import {Loader} from "react-feather";

export const StyledMedia = styled(`div`)`
  flex: 1;
  height: 100%;
  margin: 0 auto;
  ${sv.flexCenter};
`;

export const Container = styled(`div`)`
  flex: 1;
  max-width: 1920px;
  padding: ${props => props.isMobile ? '0 30px' : '0 48px'};
  ${sv.flexColumn};
  justify-content: space-between;
  min-height: 100vh;
  @media(max-width: 520px) {
  	width: 100%;
    padding: 0 16px;
  }
`;

export const IsVerifying = styled(`div`)`
  width: 100%;
  height: 48px;
  color: ${sv.colors.cta};
  ${sv.flexCenter};
  h3 {
    margin-right: 16px;
  }
`;

export const AnimatedLoader = styled(Loader)`
  @keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(359deg);}
  }
  -webkit-animation-name: spin;
  -webkit-animation-duration: 2000ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-name: spin;
  -moz-animation-duration: 2000ms;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
`;

export const CallToAction = styled(`div`)`
  ${sv.buttonBase};
  background-color: ${sv.colors.cta};
  border: 2px #ffffffdd solid;
  color: ${sv.colors.light};
  box-shadow: 0 2px 4px rgba(0, 0, 0, .05);
  white-space: nowrap;

  &:hover {
    box-shadow: 0 3px 6px rgba(0, 0, 0, .1);
  }
`;

export const List = styled('ul')`
    list-style: disc;
    margin: 6px;
    padding-inline-start: 20px;
`;

export const ListItem = styled('li')`
    padding: 2px;
`;

// media content
export const MediaContent = styled(`div`)`
  height: 100%;
  min-height: 350px;
  flex: 1;
  background: ${sv.colors.light};
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,.25);
  ${sv.flexRow};
  align-items: flex-start;
  ${sv.box};
  margin-bottom: 20px;
  
  @media(max-width: 520px) {
      width: 100%;
      margin: 0 auto;
  }
`;